export default __webpack_public_path__ + "static/header-bg-12b2663a54ddbf0e069aa9c9e9c6fd79.png";